import axios from "axios";

export const getFeaturedAdResults = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredadresults/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const editFeaturedAdResults = (data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredadresults/editfeaturedadresults",
      data
    )
    .then((res) => res.data);
};
